import { Stack } from "@components/Stack";
import { Typography } from "@components/Typography";

import { useToysHowToGuideQuery } from "@storage/queries/bucket";

export const ToyDescription = () => {
	const { data: toysHowToGuide, isSuccess } = useToysHowToGuideQuery();

	if (!isSuccess) return null;

	return (
		<div className="flex w-full flex-col gap-5">
			{toysHowToGuide.map(({ title, description }) => (
				<Stack key={title} spacing={1}>
					<Typography type="h2" size="sm" weight="bold">
						{title}
					</Typography>
					<Typography size="sm" color="msg_time">
						{description}
					</Typography>
				</Stack>
			))}
		</div>
	);
};
